import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { mapActions } from 'vuex';

import * as accountTypes from '@account/store/types'

import { LoginActionPayload } from '@account/store/actions';

// data type
declare type EumParam = {
    type: string, // type code (1,2,3 ..)
    service: string, // called by
    returnUrl: string, // to redirect (encoded value)
    userid?: string // personcode or email
}

@Component({
    name: 'RedirectView',
    methods: {
        ...mapActions({
            login: accountTypes.LOGINEX,
        })
    }
})
export default class RedirectView  extends Vue {

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    // return URL
    @Prop({ type: String, default: '' }) returnUrl!: string;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    errorTitle: string = this.$t('오류').toString();
    errorMessage: string = '';

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    login!: (payload: LoginActionPayload) => Promise<account.TCurrent | null>

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    load(){
        const { query } = this.$route;
        if(query.eumparam){
            try{
                const data : EumParam = JSON.parse(decodeURIComponent(query.eumparam.toString()));
                switch(data.type){
                    case '1': // logon -> redirect
                        console.log('RedirectView', 'data', data);
                        if(data.userid){
                            this.loginService(data.userid, data.returnUrl);
                        }
                        else{
                            throw new Error('[NOT FOUND USERID]');
                        }
                        break;
                    default:
                        throw new Error('[NOT EXIST TYPE]');
                }
            }
            catch(err){
                this.handleError(err);
            }
        }
        else{
            this.handleError(new Error('[NOT FOUND EUMPARAM]'));
        }
        
    }

    /**
     * 로그인 처리 후 returnUrl 로 이동시킵니다.
     */
    async loginService(userid: string, returnUrl: string){
        try{
            const user = await this.login({ username: userid, password: ''})
            
            if(user){
                this.goToPage(returnUrl);
            }else{
                this.handleError(new Error('[NOT FOUND USER] :' + userid), this.$t('로그인에_실패하였습니다').toString());
            }
        }
        catch(err){
            this.handleError(err, this.$t('로그인에_실패하였습니다').toString());
        }
    }

    /**
     * 로그인 오류를 처리합니다.
     * @param err 
     */
    handleError(err: any, msg?: string){
        const _this = this;
        console.error(err);
        if(msg && msg.length){
            this.errorMessage = msg;
        }
        else{
            this.errorMessage = err.message || '';
        }
    }

    /**
     * 해당 URL 로 페이지를 이동시킵니다.
     * @param url 
     */
    goToPage(url: string){
        try{
            var targetUrl = decodeURIComponent(url);
            if(targetUrl.indexOf('?') > -1){
                targetUrl += '&EumRedirect=1';
            }
            else{
                targetUrl += '?EumRedirect=1';
            }
            if (targetUrl.startsWith('http://') || targetUrl.startsWith('https://')) {
                location.href = targetUrl;
            }
            else{
                location.href = location.origin + targetUrl;
            }
        }
        catch(err){
            this.handleError(err);
        }
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created(){
        this.load();
    }
    
    
    
}